{
  "taxes-and-prorations": "Taxes & Prorations",
  "basic": "Basic",
  "tax": "Tax",
  "name": "Name",
  "prorate-using": "Prorate Using",
  "installment-amount": "Installment Amount",
  "per-diem": "Per Diem",
  "days-per-year": "Days Per Year",
  "seller": "Seller",
  "buyer": "Buyer",
  "per-diem-decimals": "Per Diem Decimals",
  "pull-tax-to-impound-disclosure": "Pull tax to impound disclosure",
  "include-1099": "Include in 1099",
  "tax-info": "Tax Info",
  "parcel-id": "Parcel ID",
  "paid-thru": "Paid Thru",
  "next-due": "Next Due",
  "payment-schedule": "Payment Schedule",
  "annual": "Annual",
  "quaterly": "Quaterly",
  "monthly": "Monthly",
  "other": "Other",
  "proration": "Proration",
  "proration-date": "Proration Date",
  "installment-start-date": "Installment Start Date",
  "installment-end-date": "Installment End Date",
  "number-of-days-in-period": "Number of Days in Period",
  "days-year": "Days per Year",
  "debited-party": "Debited Party",
  "buyer-owes-seller": "Buyer Owes Seller",
  "seller-owes-buyer": "Seller Owes Buyer",
  "prorated-amount":"Prorated amount"
}
